import Modal from 'react-overlays/Modal';
import styled from 'styled-components/macro';

import { FormHeading } from './Form.styled';

export const SidebarModal = styled(Modal)<{ $overflowYHidden?: boolean; $zIndex?: number }>`
  position: fixed;
  top: 0;
  right: ${({ theme }) => theme.spacing.zero};
  z-index: ${({ theme, $zIndex }) => $zIndex ?? theme.zIndex.zIndex5};

  width: 100%;
  max-width: 30rem;
  height: 100%;
  overflow-y: ${({ $overflowYHidden }) => ($overflowYHidden ? 'hidden' : 'scroll')};

  color: ${({ theme }) => theme.colors.black_5};

  background-color: ${({ theme }) => theme.colors.white};
  outline: none;
`;

export const SidebarModalBody = styled.div`
  padding: ${({ theme }) => theme.spacing.two} ${({ theme }) => theme.spacing.two} 8rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme }) => theme.spacing.one_2} ${({ theme }) => theme.spacing.one_2} 8rem;
  }
`;

export const SidebarHeading = styled(FormHeading)``;

export const Backdrop = styled.div<{ $zIndex?: number }>`
  position: fixed;
  top: ${({ theme }) => theme.spacing.zero};
  right: ${({ theme }) => theme.spacing.zero};
  bottom: ${({ theme }) => theme.spacing.zero};
  left: ${({ theme }) => theme.spacing.zero};
  z-index: ${({ theme, $zIndex }) => $zIndex ?? theme.zIndex.zIndex5};

  background-color: ${({ theme }) => theme.colors.black_100};
  opacity: 0.75;
`;
